/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyPowerBIIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-powerBI" */ './utils').then((m) => m.PowerBIIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/powerBI/icon' },
);

const LazyPowerBISearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-powerBI-search-result" */ './utils').then(
			(m) => m.PowerBISearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/powerBI/search-result-icon' },
);

const LazyPowerBIIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-powerBI-borderless" */ './utils').then(
			(m) => m.PowerBIIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/powerBI/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const PowerBIIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyPowerBIIconComponent />
	</Suspense>
);

export const PowerBISearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyPowerBISearchResultIconComponent />
	</Suspense>
);

export const PowerBIIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyPowerBIIconBorderlessComponent />
	</Suspense>
);
